<template>
    <div class="meeting-card pt-40 container-370">
        <h2 class="room-number mb-20">
            #{{meeting.id}}の予約
        </h2>
        <div class="meeting-card-body">
            <div class="meeting-date mb-2 text-center">{{getMeetingFullTime(meeting.start_at, meeting.end_at)}}</div>
            <div class="meeting-time mb-2 text-center" v-if="checkShowTimeMeeting(meeting)">{{getMeetingStartEndTime(meeting.start_at, meeting.end_at)}}</div>
            <div class="meeting-type mb-2 text-center">{{meeting.category ? meeting.category.name_kanji : ''}}</div>
            <div class="pharmacist-info mt-10 text-center">
              <div v-if="meeting.category_id === 1">
                <p>
                  {{meeting.user ? meeting.user.name : ''}} (患者)
                </p>
                <p>{{meeting.pharmacy.pmc_name}} - 主催者</p>
              </div>
              <div v-else>
                <p v-for="participant in meeting.participants" :key="participant.user_id">
                  {{participant.user_name}}
                  <span v-if="participant.user_type === USER_TYPE_PATIENT">(患者)</span>
                  <span v-if="participant.user_type === USER_TYPE_PHARMACIST">(薬剤師)</span>
                  <span v-if="participant.user_type === USER_TYPE_OTHER && participant.occupation">({{participant.occupation}})</span>
                </p>
                <p>
                  {{meeting.user ? meeting.user.name : ''}}
                  <span v-if="meeting.user && meeting.user.type === USER_TYPE_PHARMACIST">(薬剤師)</span>
                  <span v-if="meeting.user && meeting.user.type === USER_TYPE_OTHER && meeting.user.occupation">({{meeting.user.occupation}}) - 主催者</span>
                </p>
              </div>
            </div>
            <div class="meeting-content">{{meeting.title || `#${meeting.id}`}}</div>
        </div>
      <div v-if="isShowBlockButton">
        <el-select class="quality-select-box h-44" v-model="videoProfile" placeholder="高解像度">
            <el-option v-for="item in videoResolutions" :key="item.videoProfile" :label="item.resolution" :value="item.videoProfile"></el-option>
        </el-select>

        <div class="buttons-flex mb-10">
          <span v-if="canJoinMeeting" class="button success medium flex-1" @click="goToCall()">ビデオ通話を開始する</span>
          <span v-else class="button disabled medium flex-1">ビデオ通話を開始する</span>
        </div>

        <div class="buttons-flex mb-10">
          <a v-if="canJoinMeeting" class="flex-1 button default" @click="showUrlShareMeeting">この予約をシェア</a>
          <a v-else class="flex-1 button disabled default">この予約をシェア</a>
          <span v-if="!cancelableMeeting()" class="button disabled medium ml-10 flex-1">この予約を取り消す</span>
          <span v-else class="button outline-warning medium ml-10 flex-1" @click="handleClickCancelMeeting()">この予約を取り消す</span>
        </div>

        <div v-if="canUpdateMeeting" class="buttons-flex mb-10">
          <router-link
            :to="{name: 'meetings.edit', params: {id: meeting.id}}"
            class="flex-1 button default"
          >
            編集する
          </router-link>
        </div>
        <input type="text" id="meeting-share-url">

      </div>
      <div v-else class="quality-select-box"></div>
      <div v-if="meeting.enable_askpay">
        <div v-if="this.buttonStatus === BUTTONS_ONLINE_PAYMENT" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            オンラインでの決済を希望する
          </a>
        </div>

        <div v-if="this.buttonStatus === BUTTONS_PAYMENT_METHOD" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            決済方法を確認する
          </a>
        </div>

        <div v-if="this.buttonStatus === BUTTONS_SHIPPING_ADDRESS" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            配送先を設定する
          </a>
        </div>

        <div v-if="this.buttonStatus === BUTTONS_PAYMENT_DETAIL" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            お支払情報を確認する
          </a>
        </div>

        <div v-if="this.buttonStatus === BUTTONS_CREATE_INVOICE" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            オンラインで請求を依頼する
          </a>
        </div>

        <div v-if="this.buttonStatus === BUTTONS_INVOICE_DETAIL" class="buttons-flex mb-10">
          <a class="flex-1 button default"
            :class="{'is-disabled': isLoading}"
            @click.stop="getInfo"
          >
            請求情報を確認する
          </a>
        </div>

        <div v-if="this.isPapError" class="text-error mb-10">
          オンライン決済機能で不明なエラーが発生しています。<br>
          しばらく経ってからご確認願います。
        </div>
      </div>

      <div class="overlay-modal" v-if="showModal">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <span class="block mb-5">取消理由（必須）</span>
            <el-input
              type="textarea"
              :rows="7"
              placeholder=""
              v-model="messageDeleteMeeting">
            </el-input>
          </div>
          <div class="modal-footer">
            <span class="cancel-btn" @click="showModal = false">操作を取消し</span>
            <span v-if="messageDeleteMeeting && !isSubmittingMeetingAction" class="confirm-btn" @click="cancelMeeting()">送信</span>
            <span v-else class="confirm-btn banned" >送信</span>
          </div>
        </div>
      </div>

      <div class="overlay-settlement-modal" v-show="showPapModal">
        <div class="modal-content">
          <div class="modal-header">
            <div @click="closeModal" class="button default">X 閉じる</div>
          </div>
          <div class="modal-body">
            <iframe id="detail_iframe"
              frameborder="0"
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import moment from 'moment'
import MeetingsApi from '@/api/meeting'
import MasterApi from '@/api/master'
import axios from 'axios'
import {
  VIDEO_RESOLUTIONS,
  USER_TYPE_OTHER,
  USER_TYPE_PATIENT,
  USER_TYPE_PHARMACIST,
  CANCEL_TYPE_CANCEL,
  PAYMENT_TEMPORARILY_SAVED,
  PAYMENT_REQUESTED,
  PAYMENT_REQUESTED_CASH_ON_DELIVERY,
  PAYMENT_COMPLETED,
  PAYMENT_EXPIRED,
  PAYMENT_ERROR,
  PAYMENT_CANCELED,
  PAYMENT_REQUESTED_CREATE_INVOICE,
  PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS,
  PAYMENT_AKADEN,
  PAYMENT_NO_EXISTS_DATA,
  MEETING_CATEGORY_GUIDANCE,
  BUTTONS_NONE,
  BUTTONS_ONLINE_PAYMENT,
  BUTTONS_PAYMENT_METHOD,
  BUTTONS_SHIPPING_ADDRESS,
  BUTTONS_PAYMENT_DETAIL,
  BUTTONS_CREATE_INVOICE,
  BUTTONS_INVOICE_DETAIL
} from '@/const'
import {convert2LocalTime, apiErrorDialog} from '@/helpers'
import {isJoinButtonEnabled, scheduleJoinRefresh as createJoinRefreshSchedule} from '@/utils/joinWindow'
import _ from 'lodash'

export default {
  data () {
    return {
      VIDEO_RESOLUTIONS,
      USER_TYPE_OTHER,
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      CANCEL_TYPE_CANCEL,
      PAYMENT_TEMPORARILY_SAVED,
      PAYMENT_REQUESTED,
      PAYMENT_REQUESTED_CASH_ON_DELIVERY,
      PAYMENT_COMPLETED,
      PAYMENT_EXPIRED,
      PAYMENT_ERROR,
      PAYMENT_CANCELED,
      PAYMENT_REQUESTED_CREATE_INVOICE,
      PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS,
      PAYMENT_AKADEN,
      PAYMENT_NO_EXISTS_DATA,
      MEETING_CATEGORY_GUIDANCE,
      BUTTONS_NONE,
      BUTTONS_ONLINE_PAYMENT,
      BUTTONS_PAYMENT_METHOD,
      BUTTONS_SHIPPING_ADDRESS,
      BUTTONS_PAYMENT_DETAIL,
      BUTTONS_CREATE_INVOICE,
      BUTTONS_INVOICE_DETAIL,
      params: {},
      meeting: {},
      videoProfile: '720p',
      shareMeeting: false,
      shareMeetingUrl: '',
      messageDeleteMeeting: '',
      showModal: false,
      videoResolutions: [],
      showPapModal: false,
      isPharmacist: this.$auth.user().type === USER_TYPE_PHARMACIST,
      paymentStatus: null,
      papBaseUrl: '',
      info: {},
      buttonStatus: BUTTONS_NONE,
      isPapError: false,
      isLoading: false,
      isSubmittingMeetingAction: false,
      clearJoinRefresh: null
    }
  },
  computed: {
    canJoinMeeting () {
      return isJoinButtonEnabled(this.meeting)
    },
    canUpdateMeeting () {
      if (this.meeting.user_id !== this.$auth.user().id) return false
      if (this.meeting.status === 'finished' || this.meeting.status === 'canceled') return false
      return true
    },
    isShowBlockButton () {
      const meeting = this.meeting
      const startAt = moment(this.meeting.start_at)
      const endAt = moment(this.meeting.end_at)
      const now = moment()
      if ((meeting.status === 'canceled' && endAt.isAfter(now)) || (meeting.status === 'pending' && endAt.isBefore(now))) return false
      if (meeting.status === 'finished' || (meeting.status === 'canceled' && endAt.isBefore(now)) || (meeting.status === 'accepted' && endAt.isBefore(now))) { return false }
      if (meeting.status === 'discontinuation') return false

      return true
    }
  },
  watch: {
    paymentStatus: function (newPaymentStatus) {
      if (this.meeting.category_id !== MEETING_CATEGORY_GUIDANCE) {
        this.isPapError = false
        return
      }

      if (this.isPharmacist) {
        switch (parseInt(newPaymentStatus)) {
          case PAYMENT_NO_EXISTS_DATA:
          case PAYMENT_CANCELED:
            this.isPapError = false
            this.buttonStatus = BUTTONS_CREATE_INVOICE
            break
          case PAYMENT_TEMPORARILY_SAVED:
          case PAYMENT_REQUESTED:
          case PAYMENT_REQUESTED_CASH_ON_DELIVERY:
          case PAYMENT_COMPLETED:
          case PAYMENT_EXPIRED:
          case PAYMENT_ERROR:
          case PAYMENT_REQUESTED_CREATE_INVOICE:
          case PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS:
          case PAYMENT_AKADEN:
            this.isPapError = false
            this.buttonStatus = BUTTONS_INVOICE_DETAIL
            break
          default:
            this.isPapError = true
            this.buttonStatus = BUTTONS_NONE
        }
      } else {
        switch (parseInt(newPaymentStatus)) {
          case PAYMENT_NO_EXISTS_DATA:
          case PAYMENT_CANCELED:
            this.isPapError = false
            this.buttonStatus = BUTTONS_ONLINE_PAYMENT
            break
          case PAYMENT_TEMPORARILY_SAVED:
          case PAYMENT_REQUESTED_CREATE_INVOICE:
            this.isPapError = false
            this.buttonStatus = BUTTONS_PAYMENT_METHOD
            break
          case PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS:
            this.isPapError = false
            this.buttonStatus = BUTTONS_SHIPPING_ADDRESS
            break
          case PAYMENT_REQUESTED:
          case PAYMENT_REQUESTED_CASH_ON_DELIVERY:
          case PAYMENT_COMPLETED:
          case PAYMENT_EXPIRED:
          case PAYMENT_ERROR:
          case PAYMENT_AKADEN:
            this.isPapError = false
            this.buttonStatus = BUTTONS_PAYMENT_DETAIL
            break
          default:
            this.isPapError = true
            this.buttonStatus = BUTTONS_NONE
        }
      }
    }
  },
  methods: {
    async fetchMeeting () {
      const resolutionRes = await MasterApi.getResolutions()
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      if (resolutionRes && resolutionRes.data) {
        this.videoResolutions = []
        _.forEach(resolutionRes.data.data, n => {
          const item = _.find(VIDEO_RESOLUTIONS, m => m.key === n)
          if (item) this.videoResolutions.push(item)
          if (item && item.key === '640x480') this.videoProfile = item.videoProfile
        })
      }
      await this.refreshMeeting()
      await this.setPapBaseUrl()
    },
    async refreshMeeting () {
      const $ = this
      const meetingID = this.$route.params.id
      const res = await MeetingsApi.getById(meetingID)
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return $.$router.push({name: 'NotFound'})
          }
          apiErrorDialog(this, error)
        })

      if (!res) return

      this.meeting = res.data.data
      const localTime = moment.tz.guess()
      this.meeting.start_at = convert2LocalTime(this.meeting.start_at, localTime)
      this.meeting.end_at = convert2LocalTime(this.meeting.end_at, localTime)
      this.params['postal_code'] = this.meeting.user.js_yubin
      this.params['prefecture'] = this.meeting.user.js_prefecture
      this.params['city'] = this.meeting.user.js_city
      this.params['address_1'] = this.meeting.user.js_ext
      this.params['phone_number'] = this.meeting.user.tell

      this.shareMeetingUrl = `${process.env.APP_URL}/call?key=${this.meeting.key}?video_profile=${this.videoProfile}`
      this.setupJoinRefreshSchedule()
    },
    async setPapBaseUrl () {
      const res = await MasterApi.get()
        .catch((error) => apiErrorDialog(this, error))
      if (!res) return
      this.papBaseUrl = res.data.data.pap_base_url
      this.getpaymentStatus()
    },
    checkShowTimeMeeting (meeting) {
      const startTime = moment(meeting.start_at)
      const endTime = moment(meeting.end_at)
      if (startTime.year() === endTime.year()) return true
      return false
    },
    goToCall () {
      if (!this.canJoinMeeting) return
      if (this.isEndingMeeting()) {
        return this.handleExpiredMeetingAction('入室できません。')
      }
      this.$router.push({name: 'meetings.call', params: {id: this.meeting.id}, query: {video_profile: this.videoProfile}})
    },
    getMeetingFullTime (startTime, endTime) {
      startTime = moment(startTime)
      endTime = moment(endTime)
      if (startTime.year() === endTime.year()) {
        return `${startTime.year()} 年 ${startTime.month() + 1}月${startTime.date()}日 (${this.getDayOfWeekJapanese(startTime.day())})`
      }
      return `${startTime.format('YYYY/MM/DD')} (${this.getDayOfWeekJapanese(startTime.day())}) ${startTime.format('HH:mm')}` +
             ` ~ ${endTime.format('YYYY/MM/DD')} (${this.getDayOfWeekJapanese(endTime.day())}) ${endTime.format('HH:mm')}`
    },
    getMeetingStartEndTime (start, end) {
      start = moment(start)
      end = moment(end)
      return `${start.format('HH:mm')} ~ ${end.format('HH:mm')}`
    },
    getDayOfWeekJapanese (day) {
      if (day === 0) return '日'
      if (day === 1) return '月'
      if (day === 2) return '火'
      if (day === 3) return '水'
      if (day === 4) return '木'
      if (day === 5) return '金'
      if (day === 6) return '土'
    },
    showUrlShareMeeting () {
      if (!this.canJoinMeeting) return
      if (this.isEndingMeeting()) {
        return this.handleExpiredMeetingAction('予約をシェアできません。')
      }
      this.shareMeeting = true
      this.shareMeetingUrl = `${process.env.APP_URL}/call?key=${this.meeting.key}&video_profile=${this.videoProfile}`
      const inputUrlShareMeeting = document.getElementById('meeting-share-url')
      inputUrlShareMeeting.value = this.shareMeetingUrl
      const copyText = document.getElementById('meeting-share-url')
      copyText.select()
      document.execCommand('copy')
      this.$message.success('clipboardにコピーしました。!')
    },
    isEndingMeeting () {
      return moment().isAfter(this.meeting.end_at)
    },
    cancelableMeeting () {
      return moment().isBefore(this.meeting.start_at)
    },
    handleExpiredMeetingAction (suffix, redirectRoute = null) {
      alert(`開催期間が終了しました。${suffix}`)
      return redirectUrl || this.$router.push({name: 'home'})
    },
    handleClickCancelMeeting () {
      if (!this.cancelableMeeting()) {
        return this.handleExpiredMeetingAction('取り消しできません。')
      }
      if (this.isEndingMeeting()) {
        return this.handleExpiredMeetingAction('入室できません。')
      }
      this.showModal = true
    },
    async cancelMeeting () {
      if (this.isSubmittingMeetingAction) return
      this.isSubmittingMeetingAction = true
      const expectedStatus = this.meeting.status
      let canceledMeeting = null
      try {
        canceledMeeting = await MeetingsApi.cancel(this.meeting.id, this.messageDeleteMeeting, CANCEL_TYPE_CANCEL, expectedStatus)
      } catch (error) {
          if (error && error.response && error.response.status === 409) {
            this.$message.warning('状態が変更されました。最新情報を再取得します。')
            this.showModal = false
            await this.fetchMeeting()
            return
          }
          apiErrorDialog(this, error)
          return
      } finally {
        this.isSubmittingMeetingAction = false
      }
      if (!canceledMeeting) return
      this.meeting = canceledMeeting.data.data
      this.$message({
        type: 'success',
        message: 'この予約は正常にキャンセルされました!'
      })
      this.showModal = false
      this.$router.push({name: 'home'})
    },
    async getpaymentStatus () {
      const resources = ['searchIdByServiceUniqueId', 'paymentStatus']
      const meetingID = this.$route.params.id
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      const resFromGetInvoiceIdApi = await axios.get(`${this.papBaseUrl}/${resources[0]}/${meetingID}`, {headers: headers})
        .catch((error) => {
          this.paymentStatus = -2
          return null
        })
      if (!resFromGetInvoiceIdApi) return
      const invoiceId = resFromGetInvoiceIdApi.data.invoiceId
      if (invoiceId) {
        const resFromGetPaymentStatusApi = await axios.get(`${this.papBaseUrl}/${invoiceId}/${resources[1]}`, {headers: headers})
          .catch((error) => {
            this.paymentStatus = -2
            return null
          })
        if (!resFromGetPaymentStatusApi) return
        this.paymentStatus = resFromGetPaymentStatusApi.data.paymentStatus
      } else {
        this.paymentStatus = PAYMENT_NO_EXISTS_DATA
      }
    },
    async getInfo () {
      if (this.isLoading) return
      this.isLoading = true
      const meetingID = this.$route.params.id
      const headers = {
        'Authorization': `Bearer ${this.$auth.token()}`
      }
      try {
        switch (this.buttonStatus) {
          case BUTTONS_SHIPPING_ADDRESS:
            const shippingAddress = await MeetingsApi.editShippingAddress(meetingID, headers)
            this.info = shippingAddress.data.data
            break
          case BUTTONS_INVOICE_DETAIL:
          case BUTTONS_PAYMENT_DETAIL:
          case BUTTONS_PAYMENT_METHOD:
            const getInvoiceDetail = await MeetingsApi.getInvoiceDetail(meetingID, headers)
            this.info = getInvoiceDetail.data.data
            break
          case BUTTONS_CREATE_INVOICE:
            const createInvoice = await MeetingsApi.createInvoice(meetingID, headers)
            this.info = createInvoice.data.data
            break
          case BUTTONS_ONLINE_PAYMENT:
            const onlinePayment = await MeetingsApi.editPaymentMethod(meetingID, headers)
            this.info = onlinePayment.data.data
        }
        this.setUrl(this.info.url, this.info.token)
      } catch (error) {
        this.isLoading = false
        apiErrorDialog(this, error)
      }
    },
    async setUrl (url, token) {
      this.showPapModal = true
      var openUrl = url
      var isFirst = true
      if (this.buttonStatus === BUTTONS_CREATE_INVOICE) {
        for (let key in this.params) {
          if (this.params[key]) {
            openUrl += (isFirst ? '?' : '&') + `${key}=${this.params[key]}`
            isFirst = false
          }
        }
      }
      var xhr = new XMLHttpRequest()

      if (openUrl) {
        xhr.open('GET', openUrl)
        xhr.onreadystatechange = handler
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
        xhr.withCredentials = true
        xhr.send()
      }

      function handler () {
        if (this.readyState === this.DONE) {
          var data_url = URL.createObjectURL(this.response)
          document.querySelector('#detail_iframe').src = data_url
        }
      }
    },
    setupJoinRefreshSchedule () {
      if (this.clearJoinRefresh) this.clearJoinRefresh()
      this.clearJoinRefresh = createJoinRefreshSchedule(this.meeting, () => this.refreshMeeting())
    },
    onVisibilityChange () {
      if (document.visibilityState === 'visible') {
        this.refreshMeeting()
      }
    },
    closeModal () {
      this.showPapModal = false
      this.isLoading = false
      document.querySelector('#detail_iframe').src = ''
    }
  },
  created () {
    this.fetchMeeting()
  },
  mounted () {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy () {
    if (this.clearJoinRefresh) this.clearJoinRefresh()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/Show.vue